import React from 'react';
import Link from 'components/UI/Link';

import * as styles from './LinkTiles.module.scss';

export default function LinkTiles({ links }) {
  return (
    <div className={styles.tilesWrapper}>
      {links.map(({ name, link }) => (
        <React.Fragment key={link}>
          {link ? (
            <Link href={link} className={styles.tileLink}>
              {name}
            </Link>
          ) : (
            <div className={styles.tile}>{name}</div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
